import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from '../../models/restResponse.mode';
import { Subgroup } from '../../models/subgroup.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubgroupService {
  private readonly baseUrl = `${environment.base_url}/subgroups`;

  constructor(private http: HttpClient) {}

  getAll(
    description: string,
    groupId: number | null | undefined,
    paginate: boolean,
    page: number | null
  ): Observable<RestResponse<Subgroup[]>> {
    const d = encodeURIComponent(description ?? '');
    let url = `${this.baseUrl}/list?description=${d}&paginate=${paginate}&page=${page}`;
    if (groupId != null && groupId !== undefined) {
      url += `&groupId=${groupId}`;
    }
    return this.http.get<RestResponse<Subgroup[]>>(url);
  }

  getById(id: number): Observable<RestResponse<Subgroup>> {
    return this.http.get<RestResponse<Subgroup>>(`${this.baseUrl}/find/${id}`);
  }

  create(subgroup: Partial<Subgroup>): Observable<Subgroup> {
    return this.http.post<Subgroup>(`${this.baseUrl}/save`, subgroup);
  }

  update(id: number, subgroup: Partial<Subgroup>): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/update/${id}`, subgroup);
  }
}
